import SectionHeading from '../HomePage/SectionHeading'

export default function Ultimate() {
    return (
        <div className="md:container px-4 mx-auto mt-48">
            <div className="-mt-10 md:mt-0">
                <div className="flex flex-col-reverse md:flex-row items-center space-y-5 md:space-y-0 md:space-x-4 pt-5">
                    <div className="md:w-2/4 order-last md:order-first">
                        <img
                            src="/assets/coaching/0.png"
                            alt="coaching"
                            className="w-full h-auto"
                        />
                    </div>
                    <div className="md:w-2/4 text-left">
                        <SectionHeading>
                            <p className="text-left">
                                Ultimate{' '}
                                <span className="olm-gradient-text">
                                    Done-For-You
                                </span>{' '}
                                Marketing Mastery
                            </p>
                        </SectionHeading>
                        <br />
                        <p className="text-xl md:text-2xl md:mr-20 ">
                            <b>We Handle Everything:</b> From Campaign Strategy
                            to Ongoing Support, Ensuring Your Success Every Step
                            of the Way!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
